module.exports = __webpack_public_path__ + "media/images/icons/bi-emoji-expressionless-7559cf27a4918fff3b59c569187963ee.png";